



































import EventCard from "@/components/EventCard.vue";
import FilterBar, { EventListFilter } from "@/components/FilterBar.vue";
import * as gqlEventList from "@/graphql/EventList.gql";
import { Category, tmCategories } from "@/models/category";
import { CityState } from "@/store/city";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { State } from "vuex-class";

@Component({
  apollo: {
    eventList: {
      query: gqlEventList,
      skip() {
        return this.filter === null;
      },
      variables() {
        return {
          categoryIds: this.filter.categoryIds,
          cityId: this.cityState.city.id,
          sort: this.filter.sort,
          start: 0
        };
      }
    }
  },
  components: {
    EventCard,
    FilterBar
  }
})
export default class EventList extends Vue {
  @State("cityModule") public cityState!: CityState;
  public filter: EventListFilter | null = null;
  public category: Category = null as any;
  private start = 0;

  @Watch("$route", { immediate: true })
  public onRouteChanged(to: Route): void {
    this.category = tmCategories.find(cat => cat.routeName === to.name)!;
  }

  public showMore(eventAmount: number) {
    this.start += eventAmount;

    this.$apollo.queries.eventList.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => ({
        eventList: {
          __typename: previousResult.eventList.__typename,
          events: [
            ...previousResult.eventList.events,
            ...fetchMoreResult.eventList.events
          ],
          hasMore: fetchMoreResult.eventList.hasMore
        }
      }),
      variables: {
        categoryIds: this.filter!.categoryIds,
        cityId: this.cityState.city!.id,
        sort: this.filter!.sort,
        start: this.start
      }
    });
  }
}
